import React, { useEffect, useState, useCallback } from 'react';
import { Tray } from '@phosphor-icons/react';
import OpenComplaintCard from './child/OpenComplaintCard';
import './OpenComplaints.css';
import { toast, ToastContainer } from 'react-toastify';
import axios from 'axios';
import Skeleton from 'react-loading-skeleton';
import { useNavigate, useLocation } from 'react-router-dom';
import QRCode from 'qrcode';
import 'react-toastify/dist/ReactToastify.css';
import 'react-loading-skeleton/dist/skeleton.css';


const TableDataLayerDispatch = () => {
    const [complaints, setComplaints] = useState([]);
    const [loading, setLoading] = useState(true);
    const [qrCodes, setQrCodes] = useState({});
    const API_BASE_URL = process.env.REACT_APP_BE_API_URL;
    const navigate = useNavigate();
    const location = useLocation();
      const APP_BASE_URL = process.env.REACT_APP_URL;

    const fetchComplaints = useCallback(async () => {
        try {
            const token = localStorage.getItem("token");
            const response = await axios.get(`${API_BASE_URL}/backend/complaints/get-non-dispatch-complaints`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                }
            });

            if (response.data.success) {
                setComplaints(response.data.data);
                generateQrCodes(response.data.data,APP_BASE_URL);
            } else {
                toast.error("Failed to fetch complaints.");
            }
        } catch (error) {
            console.error("Error fetching complaints:", error);
            toast.error("Error fetching complaints.");
        } finally {
            setLoading(false);
        }
    }, [API_BASE_URL,APP_BASE_URL]);

    const generateQrCodes = async (complaintsData,APP_BASE_URL) => {
        const newQrCodes = {};
        for (const complaint of complaintsData) {
            try {
               
                const qrCodeData = `${APP_BASE_URL}/complains/view/${complaint._id}`;
                const qrCodeUrl = await QRCode.toDataURL(qrCodeData);
                newQrCodes[complaint._id] = qrCodeUrl;
            } catch (error) {
                console.error("Error generating QR code:", error);
                newQrCodes[complaint._id] = null;
            }
        }
        setQrCodes(newQrCodes);
    };

    useEffect(() => {
        fetchComplaints();
    }, [fetchComplaints]);

    useEffect(() => {
        if (location.state?.showToast) {
            toast.success("Complaint Dispatched Successfully!");
        }
    }, [location.state]);

    const getTimeElapsed = (dateString) => {
        if (!dateString) return 'N/A';
        const now = new Date();
        const created = new Date(dateString);
        const diff = now - created;

        const minutes = Math.floor(diff / 60000);
        const hours = Math.floor(minutes / 60);
        const days = Math.floor(hours / 24);

        if (days > 0) return `${days}d ${hours % 24}h ago`;
        if (hours > 0) return `${hours}h ${minutes % 60}m ago`;
        if (minutes > 0) return `${minutes}m ago`;
        return 'Just now';
    };

    return (
        <div className="basic-data-table open-complaints-page">
            <ToastContainer position="top-right" autoClose={3000} />
            <div className="card-header bg-transparent border-bottom-0 pb-0 ">
                <div className="d-flex justify-content-between align-items-center">
                    <div>
                        <span className="open-complaints-eyebrow">Dispatch workspace</span>
                        <h2 className="text-2xl font-bold text-gray-900 mb-1">
                            Open Complaints
                        </h2>
                        <p className="text-sm text-gray-500">
                            Review incoming complaints and assign them to the appropriate officer.
                        </p>
                    </div>
                    <span className="open-complaints-count">
                        <Tray size={18} weight="duotone" aria-hidden="true" />{loading ? 'Loading…' : `${complaints.length} awaiting dispatch`}
                    </span>
                </div>
            </div>
            <div className="card-body pt-0">
                <div className="row">
                    {loading ? (
                        Array.from({ length: 6 }).map((_, index) => (
                            <div 
                            key={index} 
                            className="col-xl-4 col-lg-6 col-md-6 col-sm-12 mb-6"
                            >
                              
                                  <div className="card h-full overflow-hidden border-0 rounded-xl shadow-xs hover:shadow-md transition-all duration-300">
                                    {/* Priority Top Border (you can use a thin red bar for critical) */}
                                    <div className="h-1 w-full bg-red-500" />

                                    <div className="card-body p-5">
                                        <div className="flex flex-col md:flex-row justify-between items-start w-full gap-4">
                                        {/* Left Section */}
                                        {[...Array(7)].map((_, idx) => (
                                            <div className="flex-1 w-full space-y-3">
                                                {/* Complaint ID and Badge */}
                                                <div className="flex flex-wrap items-center justify-between gap-4 mb-2">
                                                    <Skeleton height={24} width="160px" className="rounded" />
                                                    <Skeleton height={24} width="80px" className="rounded-full" />
                                                </div>

                                                
                                                <Skeleton height={20} width="200px" className="rounded" />
                                                <Skeleton height={16} width="140px" className="rounded" />
                                            </div>

                                        ))}
                                        
                                      
                                        </div>

                                    </div>
                                    </div>

                        
                            </div>
                        ))
                        ) : complaints.length > 0 ? (
                        complaints.map((complaint) => (
                            <div key={complaint._id} className="col-xl-4 col-lg-6 col-md-6 col-sm-12">
                                <OpenComplaintCard
                                    complaint={complaint}
                                    qrCodeUrl={qrCodes[complaint._id]}
                                    reportUrl={`${APP_BASE_URL}/complains/view/${complaint._id}`}
                                    elapsed={getTimeElapsed(complaint.time_of_call)}
                                    onDispatch={() => navigate(`/dispatch/update/${complaint._id}`)}
                                />
                            </div>
                        ))
                    ) : (
                        <div className="col-12 text-center py-5 text-gray-400">You are all done! No open complaints to dispatch.</div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default TableDataLayerDispatch;
